import { useDispatch } from "react-redux";
import { updateField } from "../../features/it-user-forms/user-forms-slice";
import { useCallback } from "react";
import { UserInfo } from "../../api/user/user-api-state";
import { SystemDefault } from "../../features/gms-proposal-forms/basic-information/basic-information.state";

interface Props {
    suffixOptions: SystemDefault[];
    defaultOptionSuffix: SystemDefault;
    setSearchTypeSuffix: (value: SystemDefault) => void;
}

export const usePopulateProfileForm = ({ suffixOptions, defaultOptionSuffix, setSearchTypeSuffix }: Props ) => {
    
    const dispatch = useDispatch()
    const populateProfileUpdateForm = useCallback((user: UserInfo) => {
            const rawNumber = user.phoneNumber.startsWith("+63")
                ? user.phoneNumber.slice(3)
                : user.phoneNumber;

            const selectedSuffix =
                suffixOptions.find(item => item.name === user.suffix) ??
                defaultOptionSuffix;

            dispatch(updateField({ field: "firstname", value: user.firstname ?? "" }));
            dispatch(updateField({ field: "middlename", value: user.middlename ?? "" }));
            dispatch(updateField({ field: "lastname", value: user.lastname ?? "" }));
            dispatch(updateField({ field: "suffix", value: selectedSuffix }));
            dispatch(updateField({ field: "phoneNumber", value: rawNumber }));

            setSearchTypeSuffix(selectedSuffix);
        },
        [dispatch, suffixOptions, defaultOptionSuffix, setSearchTypeSuffix]
    );

    return {
        populateProfileUpdateForm
    }
}